package ir.hosen.resume.screen

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.styles.InterestStyle
import ir.hosen.resume.util.ProjectMock
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.ScreenItem
import ir.hosen.resume.util.bps
import kotlinx.browser.window
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Img

private val SCREEN_ID = ScreenItem.Projects.id

@Composable
fun ProjectsScreen(modifier: Modifier = Modifier) {
    Box(
        modifier = modifier.id(SCREEN_ID), contentAlignment = Alignment.Center
    ) {
        Content(modifier = modifier.width(90.vw))
    }
}

@Composable
private fun Content(modifier: Modifier = Modifier) {
    Column(
        modifier = modifier,
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(32.px)
    ) {
        Row(verticalAlignment = Alignment.Top) {
            SpanText(
                modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_CONDENSED)
                    .fontSize(32.bps()), text = "My Projects."
            )
            Img(
                src = "/portal_star.svg",
                attrs = Modifier.size(22.px).filter(invert(if (Theme.isDark) 0 else 1)).toAttrs()
            )
        }
        SpanText(
            modifier = Modifier.color(Colors.Gray).fontFamily(Res.String.ROBOTO_REGULAR).fontSize(18.bps())
                .margin(topBottom = 32.px),
            text = "Unfortunately, some of my projects can’t be open-sourced): but you can still find a few of them on my GitHub!"
        )

        SimpleGrid(
            numColumns = numColumns(base = 1, sm = 3), modifier = Modifier.gap(16.px).padding(24.px)
        ) {
            ProjectMock.entries.forEach {
                ProjectCard(
                    modifier = InterestStyle.toModifier().transition(Transition.of("transform", 1.s)),
                    src = it.src,
                    url = it.url,
                    title = it.title
                )
            }

            MoreCard(modifier = InterestStyle.toModifier().transition(Transition.of("transform", 1.s)))
        }

    }

}


@Composable
private fun ProjectCard(modifier: Modifier = Modifier, src: String, url: String, title: String) {
    Box(
        modifier = modifier.size(width = 330.px, height = 186.px).padding(topBottom = 8.px, leftRight = 16.px)
            .borderRadius(10.px).onClick { window.open(url, "_blank") }, contentAlignment = Alignment.Center
    ) {
        Image(
            modifier = Modifier.fillMaxSize().objectFit(ObjectFit.Cover).borderRadius(10.px)
                .background(Theme.onBackgroundColor),
            src = src,
        )

        Box(
            modifier = Modifier.fillMaxWidth().height(68.px).borderRadius(10.px).backgroundImage(
                linearGradient(
                    dir = LinearGradient.Direction.ToTop, from = Colors.Black, to = Colors.Transparent
                )
            ).align(Alignment.BottomCenter)
        )

        SpanText(
            modifier = Modifier.color(Colors.White).fontFamily(Res.String.ROBOTO_CONDENSED).fontSize(16.bps())
                .fontWeight(
                    FontWeight.Bold
                ).margin(bottom = 8.px, left = 16.px).align(Alignment.BottomStart), text = title
        )
    }
}

@Composable
private fun MoreCard(modifier: Modifier = Modifier) {
    Row(
        modifier = modifier.size(width = 330.px, height = 186.px).padding(topBottom = 8.px, leftRight = 16.px)
            .borderRadius(10.px).onClick { window.open("https://github.com/hossein-no1/", "_blank") },
        horizontalArrangement = Arrangement.spacedBy(4.px, alignment = Alignment.CenterHorizontally),
        verticalAlignment = Alignment.CenterVertically
    ) {

        SpanText(
            modifier = Modifier.color(Theme.onBackgroundColor).fontFamily(Res.String.ROBOTO_REGULAR).fontSize(18.bps()),
            text = "More on GitHub."
        )

        Img(
            src = "/arrow.svg", attrs = Modifier.size(14.px).filter(invert(if (Theme.isDark) 0 else 1)).toAttrs()
        )

    }
}